export default "__VITE_PUBLIC_ASSET__32836796__"